import type { WebSocketErrorCode } from './types';

export class WebSocketError extends Error {
  override readonly name = 'WebSocketError';

  constructor(
    message: string,
    readonly code: WebSocketErrorCode,
    readonly statusCode: number,
  ) {
    super(message);
  }
}
